import { EmptyState, buttonClass } from "@gf/ui";
import { Link } from "react-router";
import { useExtensionStatus } from "../lib/sso";
import { IgGlyph } from "./IgGlyph";

/** Shown wherever a page needs an Instagram account and none is connected yet. */
export function NoIgAccount({ compact = false }: { compact?: boolean }) {
  const ext = useExtensionStatus();
  return (
    <div className={compact ? undefined : "gfp-center-page"}>
      <EmptyState
        size={compact ? "sm" : "lg"}
        icon={<IgGlyph size={22} />}
        title="No Instagram account connected yet"
        description={
          ext.connected
            ? "The extension is signed in. Open instagram.com in this browser, logged into your account, then open the GramFather extension and click “Connect @yourhandle”. It shows up here within a minute."
            : "Install the extension and sign it in, open instagram.com logged into your account, then open the extension and click “Connect @yourhandle”."
        }
        action={
          ext.connected ? (
            <a className={buttonClass({ variant: "primary" })} href="https://www.instagram.com/" target="_blank" rel="noreferrer">
              Open Instagram
            </a>
          ) : (
            <Link to="/connect-extension" className={buttonClass({ variant: "primary" })}>
              Set up the extension
            </Link>
          )
        }
      />
    </div>
  );
}
